/**
 * <NightModeToggle /> — Feb 2026 · Cycle 58 (Part 4).
 * ─────────────────────────────────────────────────────────────
 * TEMPORARILY DISABLED. The Luminous World night-mode variant is
 * paused while we audit contrast + typography (kids reported the
 * dark palette was hard to read at small sizes). This module
 * intentionally renders NOTHING and force-strips the `dark` class
 * from <html> so any stale localStorage flag no longer flips the
 * theme on mount.
 *
 * To re-enable: restore the original body of this file from git
 * history and remove the "return null" short-circuit.
 */
import { useEffect } from "react";

export default function NightModeToggle() {
  useEffect(() => {
    try {
      document.documentElement.classList.remove("dark");
      // Also normalise localStorage so future NightModeToggle
      // remounts (if the feature is restored) don't auto-flip.
      localStorage.setItem("mwq_night_mode_v1", "day");
    } catch { /* SSR / quota */ }
  }, []);
  return null;
}
